import React from 'react'
import { Navigate } from 'react-router-dom';
import { isLogged } from '../../helpers/AuthHandler';

const Component = ({ children, isPrivate = false }) => {
  let logged = isLogged();
  let authorized = (isPrivate && logged === false) ? false : true;

  return authorized ? children : <Navigate to="/signin" replace />;
};

export default Component;